export type ChallengeObjective = 'production_race' | 'raid_count' | 'upgrade_count';
export type ChallengeStatus = 'pending' | 'active' | 'completed' | 'expired';

export interface ChallengeDef {
  objective: ChallengeObjective;
  name: string;
  description: string;
  targetValue: number;
  gemsReward: number;
}

export interface ChallengeData {
  id: string;
  challengerId: string;
  challengedId: string;
  challengerName: string;
  challengedName: string;
  objective: ChallengeObjective;
  targetValue: number;
  challengerProgress: number;
  challengedProgress: number;
  status: ChallengeStatus;
  winnerId: string | null;
  gemsReward: number;
  createdAt: string;
  expiresAt: string;
}

export const CHALLENGE_TEMPLATES: readonly ChallengeDef[] = [
  { objective: 'production_race', name: 'Production Race', description: 'Reach target production/s first', targetValue: 500, gemsReward: 20 },
  { objective: 'raid_count', name: 'Raid Master', description: 'Win more raids in 24h', targetValue: 3, gemsReward: 25 },
  { objective: 'upgrade_count', name: 'Builder Blitz', description: 'Upgrade more buildings in 24h', targetValue: 20, gemsReward: 15 },
];

export const MAX_ACTIVE_CHALLENGES = 3;
export const CHALLENGE_DURATION_MS = 24 * 60 * 60 * 1000; // 24h
